export default {
	currency: 'درهم',
	underConstruction: {
		header: 'الصفحه تحت الانشاء',
	},
	axios: {
		unauthorized: 'Unauthorized: Access to this resource denied',
		fault: 'Something happen wrong, please contact administrator',
	},
	404: {
		header: '404',
		subHeader: "It's look like you are lost",
	},
	header: {
		searchPlaceHolder: 'ابحث ...',
		navigation: {
			home: 'الرئيسية',
			auctions: 'المزادات',
			about: 'عن الامارات للمزادات',
			faqs: 'الاسئلة المتكررة',
			contactUs: 'اتصل بنا',
		},
		auth: {
			login: 'تسجيل الدخول ',
			register: 'انضم مجانًا',
		},
		contact: {
			call: 'اتصل بنا على',
			fullLocation: 'شرفنا في مقرنا',
			smallLocation: 'المقر',
		},
		button: {
			joinUs: 'انضم مجانًا',
			login: 'تسجيل الدخول',
			logOut: 'تسجيل الخروح',
		},
	},
	footer: {
		button: {
			subscribe: 'اشترك',
		},
		auctions: {
			name: 'المزادات',
			items: {
				title1: 'Abu Dhabi Number Plates',
				title2: 'Sharjah Number Plates',
				title3: 'Dubai Number Plates',
				title4: 'RAK Number Plates',
				title5: 'Ajman Number Plates',
				title6: 'المركبات',
				title7: 'الآليات',
				title8: '  عقارات دبي',
				title9: 'عقارات أبو ظبي',
				title10: ' باقات أرقام إتصالات المميزة',
				title11: ' بضائع متنوعة',
				title12: ' المزادات الخيرية',
			},
		},
		company: {
			name: 'الشركة',
			items: {
				title1: 'عن الإمارات للمزادات',
				title2: ' كيف بدأنا',
				title3: ' الأسئلة الشائعة',
				title4: 'اتصل بنا',
			},
		},
	},
	login: {
		sectionTitle: 'Middle East’s largest auction platform',
		form: {
			emailOrUsername: 'Email or Username',
			password: 'Password',
			keepMe: 'Keep me logged in',
			submitButton: 'Login',
		},
		troubleLink: 'Forget your password?',
		signupNote: 'Don’t have an account?',
		signupButtton: 'Join Free',
	},
	home: {
		introSection: {
			headerTitle: 'أهلًا بك في أضخم منصة مزادات في الشرق الأوسط',
			headerSecondTitle:
				'لقد قمنا بعمل مزادات على أكثر من 100 ألف مركبة و 4500 عقار',
			headerSecondSubTitle: ' وملايين البضائع المتنوعة.',
			buttonBiddingText: 'ابدأ بالمزايدة الآن',
			buttonGoogle: 'Google Play',
			buttonApple: 'App Store',
			headerDownload: 'تطبيقاتنا متاحة على',
		},
		categorySection: {
			title: 'اختر ما بين أكثر من 500 عنصر معروض في 7 فئات مختلفة',
			subTitle:
				'لقد قمنا بعمل مزادات على أكثر من 100 ألف مركبة و 4500 عقار وملايين البضائع المتنوعة.',
		},
		partners: {
			title: 'زايد بثقة',
			description:
				'الإمارات للمزادات هي أكبر منصة مزادات في الشرق الأوسط بإجمالي 800,000 بند تمت المزايدة عليه بنجاح.',
			carsAuctioned: 'Cars Auctioned',
			happyCustomers: 'Happy Customers',
			guinnessWorldRecords: 'Guinness World Records',
			appDownloads: 'App Downloads',
			raisedForCharity: 'Raised for Charity',
		},
		howItWorks: {
			title: 'كيف أبدأ؟',
			description:
				'الأمر بسيط للغاية. فقط انضم ، قم بتعيين حد مزايدتك وابدأ في المزايدة.',
			tabs: [
				{
					tabTitle: 'قم بتعيين حد مزايدتك',
					tabDescription:
						'For all auctions except properties the security deposit can be made by any of the following methods:\n' +
						'\n' +
						'\n' +
						'Credit card through our mobile application or website.\n' +
						'Bank transfer or deposit to our account.\n' +
						'Submit us a security cheque to any of our branches. \n' +
						'\n' +
						'\n' +
						'For Properties Auction the security deposit must be made by any of the following methods:\n' +
						'\n' +
						'\n' +
						'Managers cheque handed at any of Emirates Auction branches across UAE during the relevant working hours.\n' +
						'Bank transfer or deposit to our bank account.',
				},
				{
					tabTitle: 'ابدأ في المزايدة على المعروضات',
					tabDescription:
						'Cras porta tincidunt massa, id hendrerit dui rutrum scelerisque. Nullam scelerisque.',
				},
				{
					tabTitle: 'قم بإنهاء إجراءات  مزاداتك الرابحة',
					tabDescription:
						'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque ultricies lectus interdum, mollis magna maximus, vestibulum ipsum.',
				},
			],
		},
		faq: {
			title: 'لديك أسئلة؟',
			subTitle:
				'الق نظرة على الأسئلة الشائعة، وفي حال وجود استفسار يمكنك التواصل مع أحد ممثلينا.',
			viewAll: 'إظهار كل الأسئلة الشائعة',
			callUsTitle: 'لازال لديك استفسار؟',
			callUsSubTitle: 'اتصل بخطنا الساخن على مدار الساعة:',
		},
	},
	main: {
		componentLoading: 'Loading...',
	},
	register: {
		heading: 'Join Free & Start Bidding!',
		description: 'Kindly fill in your details below to register',
		acceptTerms: 'I accept the ',
		termsAndCond: 'terms & conditions',
		buttonContinue: 'Continue',
		otp: 'You will recieve an OTP on this number for verification',
		select: 'Select Country',
		fullName: 'Full Name',
		password: 'Password',
		userName: 'User Name',
		email: 'Email Address',
		mobile: 'Mobile Number',
		required: 'this filed is required',
		passwordError:
			'your password must conatain one special character and at least 8 digit',
	},
	vehicles: {
		filter: {
			searchPlaceHolder: 'Search',
			title: 'Filters',
			resetFilter: 'Reset All Filters',
			listing: {
				title: 'Listing Type',
				vehiclesRadioBtn: 'Vehicles',
				machineryRadioBtn: 'Machinery',
			},
			condition: {
				title: 'Condition',
				newConditionCheckBoxBtn: 'New',
				usedConditionCheckBoxBtn: 'Used',
				scrapConditionCheckBoxBtn: 'Scrap',
			},
			make: {
				title: 'Make',
			},
			model: {
				title: 'Model',
			},
			price: {
				title: 'Price Range (AED)',
			},
			year: {
				title: 'Year',
			},
			km: {
				title: "KM's",
			},
			search: {
				title: 'Search',
			},
			showResult: 'Show {count} Results',
		},
	},
	auth: {
		otp: {
			title: 'Join Free & Start Bidding!',
			subTitle1: 'We have sent you an sms with code to ',
			subTitle2:
				'	To complete your phone number verification please enter the 7 digit activation code',
			enterCode: 'Enter Code Here',
			resendCode: 'Resend the Code',
			changePhone: 'Change Phone Number',
			activeOTP: 'Active',
		},
	},
	carDetails: {
		specifications: {
			specifications: 'SPECIFICATIONS',
			make: 'Make',
			model: 'Model',
			year: 'Year',
			keys: 'Keys',
			extColor: 'Exterior',
			doors: 'Doors',
			transmission: 'Transmission',
			odometer: 'Odometer',
			fuel: 'Fuel Type',
			vin: 'Vin',
			trim: 'Trim',
			horsePower: 'HorsePower',
		},
		documents: {
			documents: 'DOCUMENTS',
			willBeReadyIn: 'Will be ready in ',
			view: 'View',
		},
		options: {
			options: 'Options',
		},
		briefInformation: {
			stop: 'Stop My Auto Bid At Current Price',
			confirmStop: 'Are your sure you want to stop auto-bid',
			lot: 'Lot',
			bids: 'Bids',
			odometer: 'Odometer',
			timeLeft: 'Time Left',
			addToCalender: 'Add to Calender',
			currentPrice: 'Current Price',
			minIncrement: 'Min. Increment',
			bidNow: 'Bid Now',
			confirmBid: 'Confirm Bid',
			availableLimit: 'Available Limit',
			addLimit: 'You need to add Deposit Limit for this type.',
			signIn: 'Sign In to place a bid.',
			termsAgreement:
				'I agree to Terms and Conditions & I have inspected the item',
			autoBid: 'Auto Bid',
			errors: {
				exceedLimit: "You don't have enough limit to bid",
				belowMinBidValue: 'Value should exceed the minimum Bid value',
				notMultiplesMinIncreasing:
					'The increasing value should be multiples of minimum increasing value',
			},
		},
		paymentDetails: {
			paymentDetails: 'PAYMENT DETAILS',
		},
		terms: {
			title: 'TERMS & CONDITIONS',
			termsList: [
				{
					body:
						'1. Note that the rules and regulations contained in this agreement can not be used against the ' +
						'"Emirates Auction," but due to it such as the Convention governing the relationship between all' +
						' relevant parties the site, note that any ambiguity in a regulation or a misunderstanding can not' +
						' be refuted in a negative impact on the interest of any of the parties. Can not resort to ' +
						'any regulations or laws other than regulations and laws set forth by the "Emirates Auction," ' +
						'below, but the event occurred Executive Director of the company confirms its commitment to ' +
						'the regulations and other laws, note that any agreement is signed by the authorized official, ' +
						'either verbally or in writing, not necessary to "Emirates Auction" any responsibilities ' +
						'or legal obligations. Recommend "Emirates Auction," all participants and members to ' +
						'read the regulations and laws governing its relationship with its customers, ' +
						'since customers are to continue the registration process, including approval of ' +
						'all of the Provisions of the regulations of the laws of nature proceed with the ' +
						'relationship between the parties.',
				},
			],
		},
		faqs: {
			title: 'FREQUENTLY ASKED QUESTION',
		},
	},
	vehicleDetails: {},
	stillHaveQuestions: {
		title: 'STILL HAVE QUESTIONS?',
		description:
			'Don’t worry! Just send us your enquiries and we will get back to you within 48 hours.',
	},
	form: {
		fullName: 'Full Name',
		email: 'Email Address',
		mobile: 'Mobile Number',
		enquiry: 'Enquiry',
		submit: 'Submit',
	},
	plans: {
		filter: {
			type: {
				title: 'Filter by Package Type',
				all: 'All',
				silver: 'Silver',
				gold: 'Gold',
				platinum: 'Platinum',
				diamond: 'Diamond',
			},
			price: {
				title: 'Price Range (AED)',
			},
			button: {
				subtitle1: 'Show',
				subtitle2: 'Results',
			},
		},
	},
	simDetails: {
		package: {
			planPackageHelper:
				'Package can be activated with either of the plans below',
			flexible: 'Flexible',
			local: 'Local',
			applicable: 'Applicable',
			notApplicable: 'Not Applicable',
		},
		branches: {
			panelTitle: 'E.A. BRANCH',
			panelDescription:
				'Once you win the bid, you will have the option to get the item delivered to you for an additional cost.',
			locationTitle: 'DELIVERY LOCATION',
			branchTimings: 'Branch Timings',
		},
	},
	plates: {
		info: {
			viewOnMyCar: 'View on My Car',
			long: 'Long',
			short: 'Short',
		},
		filter: {
			type: {
				title: 'VIP Plan Type',
				all: 'All',
				threeDigits: '3 Digits',
				fourDigits: '4 Digits',
				fiveDigits: '5 Digits',
			},
			price: {
				title: 'Price Range (AED)',
			},
			button: {
				subtitle1: 'Show',
				subtitle2: 'Results',
			},
		},
		details: {
			delivery: {
				title: 'DELIVERY',
				description:
					'Once you win the bid, you will have the option to get the item delivered to you for an additional cost.',
			},
			terms: {
				title: 'TERMS & CONDITIONS',
				termsList: [
					{
						body:
							'1. Note that the rules and regulations contained in this agreement can not be used against the ' +
							'"Emirates Auction," but due to it such as the Convention governing the relationship between all' +
							' relevant parties the site, note that any ambiguity in a regulation or a misunderstanding can not' +
							' be refuted in a negative impact on the interest of any of the parties. Can not resort to ' +
							'any regulations or laws other than regulations and laws set forth by the "Emirates Auction," ' +
							'below, but the event occurred Executive Director of the company confirms its commitment to ' +
							'the regulations and other laws, note that any agreement is signed by the authorized official, ' +
							'either verbally or in writing, not necessary to "Emirates Auction" any responsibilities ' +
							'or legal obligations. Recommend "Emirates Auction," all participants and members to ' +
							'read the regulations and laws governing its relationship with its customers, ' +
							'since customers are to continue the registration process, including approval of ' +
							'all of the Provisions of the regulations of the laws of nature proceed with the ' +
							'relationship between the parties.',
					},
				],
			},
		},
		physical: {
			startAt: 'Auction starts at',
			addToCalender: 'Add to calendar',
			registerForEvent: 'Register for Event',
			location: 'Location',
			viewOnMyCar: 'View on Car',
		},
	},
	plateModal: {
		header: 'Please Select Plate Emirate',
	},
	shoppingCart: {
		title: 'Shopping Cart Summary',
		subtotal: 'Subtotal',
		checkout: 'Checkout',
	},
	myDeposits: {
		notAvailable: 'Not Available',
		requestRefund: 'Request Refund',
		increaseLimit: 'Increase Limit',
		subHeader: 'Select one of the deposit method’s to proceed',
		cancelAndBack: 'Cancel & back to deposit dashboard?',
		refundCreditCardTitle: 'Request Refund by Credit Card',
		refundCreditCardSubHeader:
			'Amounts blocked on credit cards will be automatically released after 14 days.',
		noCreditCardDeposit: 'No Credit Card Deposit Currently Exist',
		refundChequeTitle: 'Request Refund by cheque',
		refundChequeSubHeader: 'cheques are available for refund.',
		noChequeDeposit: 'No Cheque Deposit Currently Exist',
		refundCashTitle: 'Request Refund by Cash',
		refundCashSubHeader: 'Total cash available for refund is',
		noCashDeposit: 'No cash available for refund',
		howMuchRefund: 'How much do you want to refund?',
		amountCreditBackTime:
			'Kindly allow 48-72 hours for the amount to be credited back into your account.',
		refundCashInputValidation:
			'Refund amount should be less than or equal "Available Deposit"',
	},
	depositHistory: {
		header: 'My Deposits History',
		subHeader: 'for everything except Properties',
		depositButton: 'My Deposits Dashboard',
		availableDeposit: 'Available deposit',
		availableLimit: 'Available limit',
		summary: 'My Transaction History Summary',
		noSummary: 'You do not have any available deposit',
	},
	propertyDetails: {
		briefInformation: {
			lot: 'سلعة ',
			bids: 'المزايدات',
			timeLeft: 'الوقت المتبقي',
			addToCalender: 'أضف إلى التقويم',
			currentPrice: 'السعر الحالي',
			minIncrement: ' الحد الأدنى للزياده',
			bidNow: 'زايد الان',
			confirmBid: 'تاكيد المزايده',
			availableLimit: 'الحد المتاح',
			addLimit: 'تحتاج إلى إضافة حد الإيداع لهذا النوع.',
			signIn: 'تسجيل الدخول لتقديم مزايدة.',
			termsAgreement: 'أوافق على الشروط والأحكام وتفحصت البند',
			autoBid: 'المزايدة التلقائية',
			errors: {
				exceedLimit: 'ليس لديك حد كاف للمزايدة',
				belowMinBidValue: 'يجب أن تتجاوز القيمة الحد الأدنى لقيمة العطاء',
				notMultiplesMinIncreasing:
					'يجب أن تكون القيمة المتزايدة مضاعفات للقيمة المتزايدة الدنيا',
			},
		},
		specifications: {
			specifications: 'المواصفات',
			type: 'النوع',
			area: 'مساحه',
			bedrooms: 'غرف نوم',
			bathroms: 'الحمامات',
			carPark: 'موقف السيارات',
			rentedTill: 'مستأجرة حتى',
			rentValue: 'قيمة الإيجار',
			rentClaimable: 'إيجار مطلوب',
			study: 'دراسة',
			storageRoom: 'غرفة تخزين',
			familyArea: 'منطقة العائلة',
			maidRoom: 'غرفة الخادمة',
		},
	},

	bidStatusMessages: {
		yourBidOf: 'مزايدتك من',
		isLeading: 'تقود حاليا',
		someoneAddHigher: 'لقد أضفت عرضًا واضاف شخصًا عرضًا أعلى',
	},
};
